import * as React from 'react';

export type LoadingTableProps = {
    classes: string,
    colspan: number,
}

export const LoadingTable = (props: React.PropsWithChildren<LoadingTableProps>) => (
    <tr className={`${(props.classes && props.classes.length ? " " + props.classes : "")}`}>
        <td colSpan={props.colspan}>
            <span className="fa-solid fa-spinner fa-spin"></span>
        </td>
    </tr>
);